import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';
import { LanguageService } from './features/translations/services/language.service';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

export function initializeApp(
  translateService: TranslateService,
  languageService: LanguageService,
) {
  return async () => {
    const currentLanguage = languageService.getUserTranslateLanguage();
    await firstValueFrom(translateService.getTranslation(currentLanguage));
    translateService.use(currentLanguage);
    translateService.setDefaultLang(currentLanguage);
  };
}
